import Head from 'next/head'
import {
  Accordion,
  Card,
  Button,
} from 'react-bootstrap'

export default function FAQ({ faqItems, background = true }) {
  return (
    <div className={`faq-fold faq ${! background && 'bg-white'}`}>
      <Head>
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqItems.map(item => {
              return {
                "@type": "Question",
                "name": item.question,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": item.answer,
                }
              }
            }),
          })}} 
        />
      </Head>
      <div className={background && 'container' }>
        <div className="row pb-4">
          <div className="col-12 mb-0">
            <h2 className={"mb-0 " + (background ? 'text-white' : '')}>Veelgestelde vragen</h2>
          </div>
        </div>
        <div className="row pt-0">
          <div className="col-12">
            <Accordion defaultActiveKey={faqItems ? 0 : null}>
              {faqItems.map((item, index) => (
                <Card key={`faq-item-${index}`}>
                  <Card.Header>
                    <Accordion.Toggle as={Button} eventKey={`faq-item-${index}`}>
                      {item.question}
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey={`faq-item-${index}`}>
                    <Card.Body>
                      {item.answer}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
      <style jsx>{`
        .faq-fold {
          padding-top: 40px;
          padding-bottom: 40px;
          background: #102E4A;
          position: relative;
          z-index: 1;
        }

        .accordion {
          background: white;
        }

        .collapse {
          padding: 20px;
        }

        h4 button {
          color: #102E4A;
          font-family: 'Open Sans', sans-serif;
          font-size: 1em;
          margin-top: 0;
        }
      `}</style>
    </div>
  )
}